const zIndex = 'zIndex';
export const aliasZIndexBuiltIns = {
    zIndex
};
export const aliasZIndex = {
    ...aliasZIndexBuiltIns
};

//# sourceMappingURL=aliasZIndex.js.map